class customProductForm extends HTMLElement {
    constructor() {
        super();

        this.formChange = this.formChange.bind(this);

        this.price = this.querySelector('[data-price]');
        this.compareAtPrice = this.querySelector('[data-compare-at-price]');
        this.form = this.querySelector('form');
        this.idSelect = this.querySelector('select[name="id"]');
        this.submitButtons = this.querySelectorAll('button[type="submit"]');
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    connectedCallback() {
        this.settings = {
            variantId: this.getAttribute('variant-id'),
            variants: JSON.parse(this.querySelector('[data-variants]').textContent ?? '[]'),
        };


        if (this.form) {
            this.form.addEventListener('submit', this.handleSubmit);

            this.form.addEventListener('change', this.formChange);
        }

        if (this.submitButtons.length > 0) {
            this.submitButtons.forEach(button => {
                button.dataset.originalText = button.textContent.trim();
            });
        }

    }

    disconnectedCallback() {
        if (this.form) {
            this.form.removeEventListener('submit', this.handleSubmit);
        }
    }

    formChange() {
        const formData = new FormData(this.form);
        const variantValueArray = Array.from({ length: 3 }, (_, index) => formData.get(`option${ index + 1 }`)).filter(Boolean);
        this.checkAvailableOptions(variantValueArray);
        this.selectId();

        if (this.price) this.updatePrice();
    }

    selectId() {
        const formData = new FormData(this.form);
        const variantValueArray = Array.from({ length: 3 }, (_, index) => formData.get(`option${ index + 1 }`)).filter(Boolean);
        const variantMatch = this.settings.variants.find(value => value.options.every((optionValue, index) => optionValue === variantValueArray[index]));

        if (variantMatch) {
            const matchingVariant = this.idSelect.querySelector(`option[value="${ variantMatch.id }"]`);
            if (matchingVariant) {
                matchingVariant.selected = true;
                this.settings.variantId = matchingVariant.value;
                this.submitButtons.forEach(button => {
                    button.textContent = matchingVariant.disabled ? 'Unavailable' : button.dataset.originalText;
                    button.classList.toggle('disabled', matchingVariant.disabled);
                });
            }
        }
    }

    checkAvailableOptions(variantValueArray) {
        const optionArrays = [
            { name: 'option1', index: 0, filterOptions: variant => variant.available, mapOptions: variant => variant.options[0] },
            { name: 'option2', index: 1, filterOptions: variant => variant.available && variant.options[0] === variantValueArray[0], mapOptions: variant => variant.options[1] },
            { name: 'option3', index: 2, filterOptions: variant => variant.available && variant.options[0] === variantValueArray[0] && variant.options[1] === variantValueArray[1], mapOptions: variant => variant.options[2] },
        ];

        optionArrays.forEach(optionArray => {
            const optionsArray = this.querySelectorAll(`[name="${ optionArray.name }"]`);
            if (optionsArray.length === 0) return;
            const optionsAvailableArray = this.settings.variants.filter(optionArray.filterOptions).map(optionArray.mapOptions);
            optionsArray.forEach(option => option.classList.toggle('disabled', !optionsAvailableArray.includes(option.value)));
        });
    }


    updatePrice() {
        const selectedVariantId = Number(this.idSelect.value);
        const selectedVariant = this.settings.variants.find(variant => variant.id === selectedVariantId);

        if (selectedVariant) {
            this.price.textContent = selectedVariant.price;
            if (this.compareAtPrice) {
                this.compareAtPrice.textContent = selectedVariant.compareAtPrice;
            }
        }
    }

    async handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(this.form);
        const variantId = formData.get('id');

        if (!variantId) {
            console.error('No variant ID found');
            return;
        }

        if (this.submitButtons.length > 0) {
            this.submitButtons.forEach(button => {
                button.disabled = true;
                button.textContent = 'Adding...';
            });
        }

        try {
            await addToCart(variantId);

            if (this.submitButtons.length > 0) {
                this.submitButtons.forEach(button => {
                    button.textContent = 'Added!';
                });
            }

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));

            const drawerOpenBtn = document.querySelector('[data-drawer-id="sidebar-cart"][data-action="open-drawer"]');
            if (drawerOpenBtn) {
                drawerOpenBtn.click();
            }

            setTimeout(() => {
                if (this.submitButtons.length > 0) {
                    this.submitButtons.forEach(button => {
                        button.disabled = false;
                        button.textContent = button.dataset.originalText || 'Add to Cart';
                    });
                }
            }, 1000);

        } catch (error) {
            console.error('Error adding product to cart:', error);

            if (this.submitButtons.length > 0) {
                this.submitButtons.forEach(button => {
                    button.disabled = false;
                    button.textContent = error.message;
                });

                setTimeout(() => {
                    if (this.submitButtons.length > 0) {
                        this.submitButtons.forEach(button => {
                            button.textContent = button.dataset.originalText || 'Add to Cart';
                        });
                    }
                }, 5000);
            }
        }
    }
}

if (!window.customElements.get("custom-product-form")) {
    window.customElements.define("custom-product-form", customProductForm);
}